import Button, { ButtonSize, ButtonVariants } from '@anm/components/buttons/Button';
import CardDetails, { CardDetailsProps } from '@anm/components/credit-card/CardDetails';
import Dialog from '@anm/components/modals/Dialog';
import Confirm from '@anm/components/notification/Confirm';
import useSwitchState from '@anm/hooks/useSwitchState';
import { useEffect, FC } from 'react';

import NoCard from '../../../credit-card/NoCard';

import { ButtonContainer, PaymentCard, PaymentDetailsBlockCard } from './Wrapper';

export type PaymentDetailsCardProps = Partial<CardDetailsProps> & {
  onClick: () => void;
  isDeletePending?: boolean;
  onDelete?: () => void;
};

const PaymentDetailsCard: FC<PaymentDetailsCardProps> = ({ last4, cardType, isDeletePending, onClick, onDelete }) => {
  const [isAlertOpen, openAlert, closeAlert] = useSwitchState();
  const hasCard = !!(last4 && cardType);
  const buttonTitle = hasCard ? 'Change Card' : 'Add Card';
  const buttonVariant: ButtonVariants = hasCard ? 'blue-heavy-border' : 'light-blue';

  useEffect(() => {
    !isDeletePending && closeAlert();
  }, [isDeletePending]);

  return (
    <>
      {isAlertOpen && (
        <Dialog onModalClose={closeAlert} onSubmit={onDelete}>
          <Confirm
            title="Delete you card?"
            titleSize="medium"
            buttonRight={{
              isPending: isDeletePending,
              text: 'Delete',
              size: 'upper-medium' as ButtonSize,
              variant: 'light-blue' as ButtonVariants
            }}
            buttonLeft={{
              isPending: false,
              text: 'Cancel',
              size: 'upper-medium' as ButtonSize,
              variant: 'blue-heavy-border' as ButtonVariants
            }}
            onLeftButtonClick={closeAlert}
            onRightButtonClick={onDelete}
          />
        </Dialog>
      )}
      <PaymentDetailsBlockCard>
        <PaymentCard>{last4 && cardType ? <CardDetails {...{ last4, cardType }} /> : <NoCard />}</PaymentCard>
        <ButtonContainer>
          <Button size="medium" variant={buttonVariant} onClick={onClick}>
            {buttonTitle}
          </Button>
          {onDelete && hasCard && (
            <Button size="medium" variant="blue-link" onClick={openAlert}>
              Delete card
            </Button>
          )}
        </ButtonContainer>
      </PaymentDetailsBlockCard>
    </>
  );
};

export default PaymentDetailsCard;
